import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuItem, Popover, Button } from '@mui/material';
import { useMemo, useState } from 'react';

const InputPresetWrapper = (props: {
  children: {} | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  presetOptions?: string[];
  selectedOption?: string;
  onSelect?: (option?: string) => void;
}) => {
  const { children, presetOptions, selectedOption, onSelect } = props;

  const [outputSelectAnchor, setOutputSelectAnchor] = useState<HTMLButtonElement>();

  const toggleOutputSelect = (event?: React.MouseEvent<HTMLButtonElement>) => {
    setOutputSelectAnchor(event?.currentTarget);
  };

  const invalidOption: boolean = useMemo(
    () => Boolean(presetOptions && selectedOption && !presetOptions.includes(selectedOption)),
    [presetOptions, selectedOption],
  );

  const outputSelectOpen = Boolean(outputSelectAnchor);
  const outputSelectId = outputSelectOpen ? 'output-select' : undefined;

  return (
    <div
      style={{
        display: 'flex',
        gap: '.5rem',
        alignItems: selectedOption && onSelect ? 'center' : 'start',
      }}
    >
      {selectedOption && onSelect ? (
        <>
          <Button
            variant="contained"
            color={invalidOption ? 'error' : 'primary'}
            sx={{
              '&.MuiButton-contained': {
                height: '40px !important',
                padding: '0px !important',
                minWidth: '40px !important',
                borderRadius: '2rem',
              },
            }}
            onClick={() => onSelect()}
          >
            <FontAwesomeIcon icon="times" />
          </Button>
          <div>
            <b>{selectedOption}</b>
            {invalidOption && (
              <p style={{ color: 'red', fontSize: '.7rem', margin: 0 }}>
                Selected option does not match a previous output
              </p>
            )}
          </div>
        </>
      ) : (
        <>
          {presetOptions && presetOptions.length > 0 && (
            <Button
              onClick={toggleOutputSelect}
              aria-describedby={outputSelectId}
              variant="outlined"
              sx={{
                '&.MuiButton-outlined': {
                  height: '40px !important',
                  padding: '0px !important',
                  minWidth: '40px !important',
                },
              }}
            >
              <div>
                <FontAwesomeIcon icon="brackets-curly" />
              </div>
            </Button>
          )}
          <Popover
            id={outputSelectId}
            open={outputSelectOpen}
            anchorEl={outputSelectAnchor}
            onClose={() => toggleOutputSelect()}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <p style={{ fontWeight: 'bold', margin: 0, padding: '.2rem .5rem' }}>
              Select from previous output
            </p>
            {presetOptions &&
              presetOptions.map(key => (
                <MenuItem key={`${key}-inputOption`} onClick={() => onSelect && onSelect(key)}>
                  {key}
                </MenuItem>
              ))}
          </Popover>
          <div style={{ flex: 1 }}>{children as unknown as React.ReactNode}</div>
        </>
      )}
    </div>
  );
};

export default InputPresetWrapper;
